import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { Header2, Button, ListSeparator } from "@activecollab/components";
import PropTypes from "prop-types";
import AddStripeCardDialog from "~/components/Subscription/BillingPaymentMethod/AddStripeCardDialog";
import FastSpringPaymentMethodInfo from "~/components/Subscription/BillingPaymentMethod/FastSpringPaymentMethodInfo";
import PrePaidPaymentMethodInfo from "~/components/Subscription/BillingPaymentMethod/PrePaidPaymentMethodInfo";
import StripePaymentMethodInfo from "~/components/Subscription/BillingPaymentMethod/StripePaymentMethodInfo";
import { showSuccessToast } from "~/components/Toast";
import { getPaymentMethod, getPaymentMethodCreditCard } from "~/store/selectors/selector.billingPaymentMethod";

const BillingPaymentMethod = ({ isCanceled }) => {
  const paymentMethod = useSelector((state) => getPaymentMethod(state));
  const creditCard = useSelector(getPaymentMethodCreditCard);
  const [showDialog, setShowDialog] = useState(false);
  const openDialog = useCallback(() => {
    setShowDialog(true);
  }, []);
  const onSubmit = useCallback(() => {
    showSuccessToast("Payment details updated.");
    setShowDialog(false);
  }, []);
  const closeDialog = useCallback(() => {
    setShowDialog(false);
  }, []);

  return (
    <div className="tw-mb-14">
      <div className="tw-flex tw-justify-between">
        <Header2
          color="primary"
          className="tw-pt-1"
        >
          Payment Method
        </Header2>
        <Button
          variant="text colored"
          onClick={openDialog}
          className="tw-mb-1"
          data-testid="Change payment method"
          disabled={isCanceled}
        >
          Change Payment Method
        </Button>
        {showDialog ? (
          <AddStripeCardDialog
            open={showDialog}
            onClose={closeDialog}
            onSubmit={onSubmit}
          />
        ) : null}
      </div>
      <ListSeparator className="tw-mx-0 tw-mt-0 tw-mb-6" />
      {paymentMethod.type === "FastSpringPaymentMethod" ? (
        <FastSpringPaymentMethodInfo paymentMethod={paymentMethod} />
      ) : paymentMethod.type === "PrePaidPaymentMethod" ? (
        <PrePaidPaymentMethodInfo />
      ) : (
        <StripePaymentMethodInfo
          paymentMethod={paymentMethod}
          isExpiredCreditCard={!!creditCard.get("is_expired")}
        />
      )}
    </div>
  );
};

BillingPaymentMethod.propTypes = {
  isCanceled: PropTypes.bool,
};

export default BillingPaymentMethod;
